import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import ComponentHeader from '../ecap/ComponentHeader';
import DashboardPathways from '../dashboard/DashboardPathways';
import ModalController from '../utility/modal/ModalController';
import { getAuthState, getOnboardingState } from '../../store/selectors';
import {
  getUserData,
  getCurrentUserId,
  updateHasBeenToDashboard,
  getData,
  getUserDashboardInfo,
} from '../../store/actions';

class Top3Careers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <div id="dashboard-top-3-careers">
            <ComponentHeader
              parent="dashboard"
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('Top {{number}} Careers', { number: '3' })
                  : t('My Top {{number}} Careers', { number: '3' })
              }
              tenant={this.props.tenant}
            />
            <ModalController />
            <div className="top-3-careers-content">
              <DashboardPathways
                setParentOnClick={this.props.setBrightOutlookModal}
                tenant={this.props.tenant}
                onboarding={this.props.onboarding}
                location={this.props.location}
                userProfile={this.props.userProfile}
                userProfileFavorites={this.props.favorites}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const userProfile = state.admin.userProfileInfo;

  return { onboarding, auth, userProfile };
};

const Top3CareersWithRouter = withRouter(
  connect(mapStateToProps, {
    getUserData,
    getCurrentUserId,
    getData,
    updateHasBeenToDashboard,
    getUserDashboardInfo,
  })(Top3Careers)
);

export default Top3CareersWithRouter;
